import { ROUTES } from '../constants';
import appendLocale from '../helpers/appendLocale';

export const getPropertyDetailsPageUrl = (urlPath, locale) =>
  appendLocale(locale, `/${ROUTES.PROPERTY_DETAILS}/${urlPath}`);

export const getProjectDetailsPageUrl = (urlPath, locale) =>
  appendLocale(locale, `/${ROUTES.PROJECT_DETAILS}/${urlPath}`);
